<div class="parameter-wrapper" *ngIf="type == 'modal' && emotions && emotions.length > 0">
    <div class="modal-subtitle parameter-wrapper-title" *ngIf="title && title != ''">
        {{ title }}
        <div class="emotion-warning-subtitle" *ngIf="showWarning">
            <img src="assets/img/warning.svg" [tooltip]="'If an emotion is selected, generated compositions may stylistically deviate from an influence'" [tooltip-marginTop]="-18" [tooltip-marginLeft]="8" [tooltip-width]="250">
        </div>
    </div>

    <div class="parameter-item emotion" *ngFor="let e of emotions; let i = index"
        [ngClass]="{ 'selected-item': e == emotion }" (click)="setEmotion(e)">
        <div class="parameter-item-emotion-title" *ngIf="e == null">None</div>
        <img [src]="getEmojiSVG(e)" *ngIf="e != null" [alt]="'Emotion: ' + getEmojiNameByEmotionID(e)">
    </div>
</div>

<div class="parameter-wrapper" *ngIf="type == 'gp' && emotions && emotions.length > 0">
    <div 
        class="parameter-item emotion emotion-small" 
        *ngFor="let e of emotions; let i = index"
        [ngClass]="{ 'selected-item': e == emotion }"
        (click)="setEmotion(e)"
        [tooltip]="getEmojiNameByEmotionID(e, true)"
        [tooltip-marginTop]="10"
        [tooltip-position]="'middle-bottom'"
        >
        <img [src]="getEmojiSVG(e)" *ngIf="e != null" [alt]="'Emotion: ' + getEmojiNameByEmotionID(e)">
    </div>
</div>

<div class="parameter-wrapper" *ngIf="type == 'create-gp' && emotions && emotions.length > 0">
    <div class="parameter-item emotion emotion-medium emotion-medium-none" (click)="setEmotion(null)">None</div>

    <div 
        class="parameter-item emotion emotion-medium" 
        *ngFor="let e of emotions; let i = index"
        [ngClass]="{ 'selected-item': e == emotion }"
        (click)="setEmotion(e)"
        [tooltip]="getEmojiNameByEmotionID(e, true)"
        [tooltip-marginTop]="10"
        [tooltip-position]="'middle-bottom'"
        >
        <img [src]="getEmojiSVG(e)" *ngIf="e != null" [alt]="'Emotion: ' + getEmojiNameByEmotionID(e)">
    </div>
</div>

<!-- 
    #################################################################################
                                    ATTRIBUTION
    The emojis used are taken from the Twemoji project https://twemoji.twitter.com/
    
    Copyright 2020 Twitter, Inc and other contributors
    Code licensed under the MIT License: http://opensource.org/licenses/MIT
    Graphics licensed under CC-BY 4.0: https://creativecommons.org/licenses/by/4.0/
-->